import RolesSelect from './RolesSelect';
import { useDefaultEndpoints } from '../../../lib/api/useDefaultEndpoints';
import { useState } from 'react';

const GlobalRolesSelectField = ({ id, roles, globalRoles }) => {
    const [rolesState, setRolesState] = useState(roles || []);
    const {editEntry} = useDefaultEndpoints('frontend-roles');
  
    const onChange = (v) => {
      editEntry(id, { global_roles: v }).then((s) => {
        setRolesState(s.global_roles);
      });
    }
  
    return (
      <div onClick={e => {
        e.preventDefault();
        e.stopPropagation();
      }}>
        <RolesSelect
          allRoles={globalRoles}
          onChange={onChange}
          value={rolesState}
        />
      </div>
    )
};

export default GlobalRolesSelectField;
